import { addDoc, collection } from 'firebase/firestore/lite';
import React, { useState } from 'react'
import { db, prodList } from '../../firebase.config';



const prolist = collection(db, "products" );


function AddProduct() {

    const [formValues, setFormValues] = useState({
        title: "",
        price: 0,
        category: "",
        image:  "",
        description: "",
        unavailable: false,
        //date: new Date()
      });

      const handleFormSubmit = async (event) => {
        event.preventDefault();
        try {
          await addDoc(prolist,{...formValues})
              
              console.log('Created :', prodList)
        } catch (error) {
          console.error("Error while creating document: ", error);
        }
      };

  return (
    <div className="px-14">
      <div className="bg-slate-800 p-6 px-12 rounded-xl">
        <p className="text-center py-3 text-green-500 text-lg font-bold tracking-widest">ADD PRODUCT</p>
        <form className="text-center" onSubmit={handleFormSubmit} >
          <div className="mb-6">
            <label
              for="text"
              className="block mb-2 text-sm font-medium  text-slate-400 text-center"
            >
              Name
            </label>
            <input
              type="text"
              id="title"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Product Name"
              required
              value={formValues.title}
                onChange={(event) =>
                 setFormValues({ ...formValues, title: event.target.value })
                }
            />
          </div>
          <div className="mb-6">
            <label
              for="price"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Price
            </label>
            <input
              type="number"
              id="price"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              value={formValues.price}
                onChange={(event) =>
                setFormValues({ ...formValues, price: event.target.value })
                }
            />
          </div>
          <div className="mb-6">
            <label
              for="category"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Category
            </label>
            <input
              type="text"
              id="category"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              value={formValues.category}
                onChange={(event) =>
                setFormValues({ ...formValues, category: event.target.value })
                }
            />
          </div>
          <div className="mb-6">
            <label
              for="category"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Image
            </label>
            <input
              type="text"
              id="image"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              placeholder="image link"
              value={formValues.image}
                onChange={(event) =>
                setFormValues({ ...formValues, image: event.target.value })
                }
            />
          </div>
          <div className="mb-6">
            <label
              for="Description"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Description
            </label>
            <input
              type="text"
              id="description"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              value={formValues.description}
                onChange={(event) =>
                setFormValues({ ...formValues, description: event.target.value })
                }
            />
          </div>
          <div className="mb-6">
            <div className="items-center h-5 text-center">
              <label className="relative inline-flex items-center mb-4 cursor-pointer">
                <input type="checkbox"  className="sr-only peer"
                  value={formValues.unavailable}
                  onChange={(event) => {
                  setFormValues({ ...formValues, unavailable: event.target.checked ? true : false })
                    console.log(event.target.checked)}
                  }
                />
                <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                <span className="ml-3 text-sm font-medium text-slate-400">
                  Item Unavailable
                </span>
              </label>
            </div>
            
          </div>
          
          <button
            type="submit"
            className=" text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"

          >
            Create Product
          </button>
        </form>
      </div>
    </div>
  )
}

export default AddProduct